import type {
    ComponentPropsWithClass,
    ComposedFC,
    ClassValue
} from "../helpers/react-helpers";
import {
    mergeAttrs,
    withClass,
    styledSpan
} from "../helpers/react-helpers"
import type {CSSProperties, ReactNode} from 'react';
import React from 'react'
import cn from 'classnames'

// .grid has negative margin to offset the margin added by .col
export const HtmlGridForm = withClass('form','grid-form')
export const GridForm = withClass('div','grid-form')
export const GridFormSingleSection = withClass('div','grid grid-form')
// export function GridForm({
//                              children,
//                              ...props
//                          }: GridFormProps) {
//     return <form {...mergeAttrs({className: 'grid-form'}, props)}>{children}</form>;
// }



export const SubGrid = React.forwardRef<HTMLDivElement,ComponentPropsWithClass<'div'>>(({className,children,...props}, ref) => (
    <div ref={ref} className={cn('row-wrapper-outer',className)} {...props}>
        <div className="row-wrapper-inner">{children}</div>
    </div>
))
SubGrid.displayName = "SubGrid"


export const GridRow = withClass('div','row')

// const GridRow = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>(({className,...props}, ref) => (
//     <div ref={ref} className={cn('row',className)} {...props} />
// ))

// export function GridRow({
//                             children,
//                             ...props
//                         }: GridRowProps) {
//     // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'Element'.
//     return <div {...mergeAttrs({className: 'row'}, props)}>{children}</div>;
// }

interface GridSectionProps extends ComponentPropsWithClass<'section'> {
    relative?: boolean
}

export function GridSection({children, relative, ...props}: GridSectionProps) {
    return (
        <section {...mergeAttrs({
            className: 'grid',
            style: {position: relative ? 'relative' : undefined}
        }, props)}>{children}</section>
    )
}

interface GridColProps {
    children: ReactNode
    flex?: string|number
    minWidth?: string|number
    maxWidth?: string|number
    width?: string|number
    grow?: true|number
    shrink?: true|number
    superUser?: boolean
    relative?: boolean
    center?: boolean
    style?: CSSProperties
    className?: ClassValue
}

export function GridCol({children, className: classNameProp, flex, width, minWidth, maxWidth, grow, shrink, superUser, relative, center, ...props}: GridColProps) {
    const style: CSSProperties = {flex, minWidth: minWidth ?? width, maxWidth: maxWidth ?? width}
    const className = [classNameProp, 'col']
    if (center) {
        className.push('vcenter')
        // style.alignItems = 'center'
        // style.display = 'flex'
    }
    if (relative) {
        style.position = 'relative'
    }
    if (shrink != null) {
        if (shrink === true) {
            style.flex = "0 1"
            style.whiteSpace = 'nowrap'
        } else {
            style.flexShrink = shrink
        }
    }
    if (grow != null) {
        if (grow === true) {
            style.flex = "1 0"
        } else {
            style.flexGrow = grow
        }
    }
    if (superUser) {
        className.push('super-user-only')
    }
    return <div {...mergeAttrs({className, style}, props)}>{children}</div>;
}

export const GridRowSingleCol: ComposedFC<typeof GridCol> = ({children,...props}) => (
    <GridRow>
        <GridCol {...props}>{children}</GridCol>
    </GridRow>
)

interface InputLabelProps extends React.ComponentPropsWithoutRef<'label'> {
    for?: string
}

export function InputLabel({...props}: InputLabelProps) {
    if (props.for) {
        props.htmlFor = props.for;
        delete props.for;
    }
    return <label {...props}/>
}

export const HelpText = withClass<'p'>('p','input-help-text');
export const ParaHelpText = withClass<'p'>('p','para-help-text');
export const ErrorText = withClass<'span'>('span','error-text no-pad');
export const NotSetText = styledSpan('not-set');
// export function HelpText(props: any) {
//     // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'Element'.
//     return <p {...mergeAttrs({className: 'input-help-text'}, props)}/>
// }

// export function GridSubsection({children,...props}) {
//     return <div {...mergeAttrs({className:'segment-container'},props)}>{children}</div>;
// }
